var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c("system-bar"),
      _c("navigation-drawer"),
      _c(
        "v-main",
        [_c("v-container", { attrs: { fluid: "" } }, [_c("router-view")], 1)],
        1
      ),
      _c("v-footer", {
        attrs: { absolute: true, height: 15 + _vm.app.bottom_height },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }